import { useState } from "react";
import apiService from "../../services/apiService";
import { useEffect } from "react";
import { Textarea } from "../../components/ui/textarea";
import { toast } from "react-toastify";


interface creditNotesProps {
  customerId?: string;
}

const CreditNotes: React.FC<creditNotesProps> = ({
  customerId
}) => {

  // const [creditNotes, setCreditNotes] = useState(""); // for displaying
  const [editedCreditNotes, setEditedCreditNotes] = useState(""); // for editing
  const [isSaving, setIsSaving] = useState(false);


  useEffect(() => {
    if (!customerId) return;
    const fetchCreditNotes = async () => {
      try {
        const res = await apiService.get(`/customers/getCreditNotes/${customerId}`);
        if (res && typeof res === "object" && "data" in res) {
          setEditedCreditNotes(typeof res.data === "string" ? res.data : "");
        } else {
          setEditedCreditNotes("");
        }
      } catch (error) {
        toast.error("Failed to fetch credit notes");
      }
    };
    fetchCreditNotes();
  }, [customerId]);


  const saveCreditNotes = async () => {
    if (!customerId) return;

    try {
      setIsSaving(true);
      await apiService.post(`/customers/saveCreditNotes/${customerId}`, {
        creditNotes: editedCreditNotes,
      });
      // setCreditNotes(editedCreditNotes);
      toast.success("Credit notes saved!");
    } catch (error) {
      toast.error("Failed to save credit notes");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="w-full pb-4 px-2">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold">Notes</h1>
          </div>
        </div>
      </div>
     
        <Textarea
            value={editedCreditNotes}
            onChange={(e) => setEditedCreditNotes(e.target.value)}
            onBlur={saveCreditNotes}
            placeholder="Enter notes..."
            className="min-h-[350px] resize-none"
          />
          {isSaving && <p className="text-sm text-gray-500 mt-2">Saving changes...</p>}
   
    </div>
  );
}

export default CreditNotes;